import { render, staticRenderFns } from "./sponsorship_employment_history.vue?vue&type=template&id=11dfd990&"
import script from "./sponsorship_employment_history.vue?vue&type=script&lang=js&"
export * from "./sponsorship_employment_history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports